import React from 'react'
import { CalendarCheck, Puzzle, Zap } from 'lucide-react'
import { toGO } from '../navBar'

const Features = () => {
  const features = [
    {
      icon: <CalendarCheck className='w-6 h-6 text-blue-600' />,
      title: 'Recurring Buy',
      description: 'Set up automatic recurring purchases of your favorite digital assets on a schedule that works for you.'
    },
    {
      icon: <Puzzle className='w-6 h-6 text-blue-600' />,
      title: 'Easy to use',
      description: 'Our platform is designed to be intuitive and user-friendly, making it simple to manage your digital assets.'
    },
    {
      icon: <Zap className='w-6 h-6 text-blue-600' />,
      title: 'Fast execution',
      description: 'Experience quick and reliable order execution with our advanced trading engine.'
    }
  ]

  return (
    <div className='max-md:px-4'>
      <div className='flex flex-col md:flex-row md:gap-16 md:items-center'>
        {/* Left Section - Mobile App Screenshots - Hidden on Mobile */}
        <div className='hidden md:block md:w-1/2' onClick={toGO}>
          <div className='relative'>
            <img
              src='https://media.graphassets.com/output=format:avif/brg7LDCTpKvYTV5hSW0g'
              alt='Recurring Buy Interface'
              className='w-full h-auto'
            />
          </div>
        </div>

        {/* Right Section - Features */}
        <div className='w-full md:w-1/2 space-y-12'>
          {features.map((feature, index) => (
            <div key={index} className='flex gap-4' onClick={toGO}>
              <div className='flex-shrink-0'>
                <div className='w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-blue-50'>{feature.icon}</div>
              </div>
              <div>
                <h3 className='text-2xl font-semibold mb-2'>{feature.title}</h3>
                <p className='text-gray-600 text-lg leading-relaxed'>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Features
